import { ConfettiShape } from '@/components/common/ConfettiAnimation/types';

export const BASE_ENTRY_DURATION = 100; // Time for number section + verified icon to animate in
export const TITLE_CHARS_PER_FRAME = 3.2;
export const DATE_CHARS_PER_FRAME = 3.7;
export const HOLD_DURATION_AFTER_COMPLETE = 13; // Hold after all content visible (~0.7s at 30fps)
export const MIN_CERTIFICATE_DURATION = 135; // Minimum display time per certificate (~3.7s at 30fps)
export const TRANSITION_DURATION = 25; // Exit animation duration

// Maximum number of certificates to display (show only most recent)
export const MAX_DISPLAY_CERTIFICATES = 5;

export const CONFETTI_CONFIG_SCENE6 = {
  PARTICLES_PER_BURST: 200, // particles per burst
  ANGLE: 90, // shoot upward
  SPREAD: 90, // cone width
  TICKS: 430, // particle lifetime
  GRAVITY: 2, // fall speed
  SCALAR: 1.75, // particle size scale
  DRIFT: 0.25, // horizontal drift
  Z_INDEX: 100, // layer order
  START_VELOCITY: 100, // launch speed
  DECAY: 0.9, // speed loss over time
  SHAPES: ['square'] as ConfettiShape[], // shapes to use
  BURST_LOCATIONS: [
    { x: 0.5, ratio: 1.0 }, // Center
    { x: 0.25, ratio: 0.6 }, // Left
    { x: 0.75, ratio: 0.6 }, // Right
    { x: 0.1, ratio: 0.4 }, // Far Left
    { x: 0.9, ratio: 0.4 }, // Far Right
  ],
} as const;
